/* eslint-disable no-unused-vars */
import axios from "axios";
import { apiServerUrl } from '../../../config/config.json';
const user_url = `${apiServerUrl}/users/bulk`;
const office_url =  `${apiServerUrl}/offices/bulk`;


export default({
    async create_offices({commit},payload){
       commit('set_loading',true)
       try {
        let type = "Office"
        let status = "Active"
        const authToken = localStorage.getItem('access_token');

        const body  = {
            office_group: payload.office_group,
            data: payload.data
        }
        console.log(body)
        const response = await axios.post(office_url, body, {
            headers: { "x-drmms-token": authToken },
        });
        commit('set_loading',false)
        return response

        
       } catch (error) {
            commit('set_loading',false)
           console.error(error)
           throw error
       }

    },
    async create_users({commit},payload){
        /*eslint no-useless-catch: "error"*/
        commit('set_loading',true)
        try {
            payload.data.forEach((x)=>{
                x.password = payload.default_password
            })
            const body  = {
                office_id: payload.office,
                users: payload.data
            }
            const authToken = localStorage.getItem("access_token");
            const response = await axios.post(user_url, body, {
                headers: { "x-drmms-token": authToken },
            });
            commit('set_loading',false)
            return response
        } catch (error) {
            console.error(error)
            commit('set_loading',false)
            throw error
        }
    },
    async process_csv({commit},payload){
        try {
            let csv_headers =  Object.keys(payload.data[0])
            let headers =[]
            csv_headers.forEach(x=>{
                let header_value = {text: x,value: x, align:"center"}
                headers.push(header_value)
            })
            if(payload.action_for == 'user_imports') {
                //Add Roles to header 
                headers.push({text: "Roles",value: "roles", align:"center"})
    
                //Add Roles to Payload Data
                payload.data[0].forEach(x=>{
                    x.role=null
                })
            }
            

            commit('set_headers',headers)
            commit('set_data',payload.data)
        } catch (error) {
            console.log(error)
        }
    },
    clear_table({commit}){
        commit('clear_table')
    },
    set_action_request({commit},payload){
        commit('action_for',payload)
    },
    set_default_password({commit},password){
        commit('set_default_password',password)
    },
    set_default_office({commit},office){
        commit('set_default_office',office)
    },
    set_user_data_with_roles({commit},data){
        commit('set_user_data_with_roles',data)
    },
    set_office_data({commit},data){
        commit('set_office_data',data)
    },
    set_office_group({commit},office_group){
        commit('set_office_group',office_group)
    }
})